// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"yD-z","smallCardRow":"zD-z","largeCardRow":"AD-z","productSearchRow":"BD-z","curatedRow":"CD-z"};